export default __webpack_public_path__ + "static/media/pizza-3.ef093068.jpg";